export const SUPPORT_EMAIL = 'feedback@pixee.ai'

// Authentik flow that presents a local username/password form with no IdP sources (added in
// ISS-7776). It lets an admin sign in as a local Authentik user to administer IdP/federation even
// when the default flow auto-redirects to the upstream IdP. Relative to the deployment host.
export const AUTHENTIK_ADMIN_LOGIN_PATH = '/authentik/if/flow/direct-authentication-flow/'

export const LOGOUT_PATH = '/api/auth/logout'

// Script-readable cookie pixee-platform writes on every browser login and expires on logout. It
// lives as long as the browser session, so its presence alongside a 401 means a session lapsed
// under a signed-in user rather than that nobody ever signed in. The SPA only reads it.
export const SIGNED_IN_COOKIE_NAME = 'PIXEE_SIGNED_IN'
